// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
export default {
  "AD": {
    "premium_rate": "[19]\\d{5}",
    "toll_free": "180[02]\\d{4}",
    "fixed_line": "[78]\\d{5}",
    "mobile": "690\\d{6}|[356]\\d{5}",
    "national": "(?:1|6\\d)\\d{7}|[135-9]\\d{5}"
  },
  "AE": {
    "premium_rate": "900[02]\\d{5}",
    "toll_free": "400\\d{6}|800\\d{2,9}",
    "shared_cost": "700[05]\\d{5}",
    "uan": "600[25]\\d{5}",
    "fixed_line": "[2-4679][2-8]\\d{6}",
    "mobile": "5[024-68]\\d{7}",
    "national": "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}"
  },
  "AF": {
    "fixed_line": "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
    "mobile": "7\\d{8}",
    "national": "[2-7]\\d{8}"
  },
  "AL": {
    "premium_rate": "900[1-9]\\d\\d",
    "toll_free": "800\\d{4}",
    "shared_cost": "808[1-9]\\d\\d",
    "personal_number": "700[2-9]\\d{4}",
    "fixed_line": "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",
    "mobile": "6(?:[78][2-9]|9\\d)\\d{6}",
    "national": "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}"
  },
  "AM": {
    "premium_rate": "90[016]\\d{5}",
    "toll_free": "800\\d{5}",
    "shared_cost": "80[1-4]\\d{5}",
    "voip": "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}",
    "fixed_line": "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",
    "mobile": "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",
    "national": "(?:[1-489]\\d|55|60|77)\\d{6}"
  },
  "AO": {
    "fixed_line": "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
    "mobile": "9[1-79]\\d{7}",
    "national": "[29]\\d{8}"
  },
  "AR": {
    "premium_rate": "60[04579]\\d{7}",
    "toll_free": "800\\d{7,8}",
    "uan": "810\\d{7}",
    "fixed_line": "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68])))\\d{6}|(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
    "mobile": "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68]))))\\d{6}|9(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|9(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|9(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
    "national": "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}"
  },
  "AT": {
    "premium_rate": "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",
    "toll_free": "800\\d{6,10}",
    "shared_cost": "8(?:10|2[018])\\d{6,10}|828\\d{5}",
    "voip": "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",
    "fixed_line": "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",
    "mobile": "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",
    "national": "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}"
  },
  "AU": {
    "premium_rate": "190[0-26]\\d{6}",
    "toll_free": "180(?:0\\d{3}|2)\\d{3}",
    "shared_cost": "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
    "voip": "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
    "pager": "163\\d{2,6}",
    "fixed_line": "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
    "mobile": "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
    "national": "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}"
  },
  "AW": {
    "premium_rate": "900\\d{4}",
    "toll_free": "800\\d{4}",
    "voip": "(?:28\\d|501)\\d{4}",
    "fixed_line": "5(?:2\\d|8[1-9])\\d{4}",
    "mobile": "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",
    "national": "(?:[25-79]\\d\\d|800)\\d{4}"
  },
  "AZ": {
    "premium_rate": "900200\\d{3}",
    "toll_free": "88\\d{7}",
    "fixed_line": "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",
    "mobile": "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",
    "national": "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}"
  },
  "BA": {
    "premium_rate": "9[0246]\\d{6}",
    "toll_free": "8[08]\\d{6}",
    "shared_cost": "8[12]\\d{6}",
    "uan": "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",
    "fixed_line": "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",
    "mobile": "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",
    "national": "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}"
  },
  "BD": {
    "toll_free": "80[03]\\d{7}",
    "voip": "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}",
    "fixed_line": "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
    "mobile": "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
    "national": "1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}"
  },
  "BE": {
    "premium_rate": "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}",
    "toll_free": "800[1-9]\\d{4}",
    "shared_cost": "7879\\d{4}",
    "uan": "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}",
    "fixed_line": "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",
    "mobile": "4[5-9]\\d{7}",
    "national": "4\\d{8}|[1-9]\\d{7}"
  },
  "BF": {
    "fixed_line": "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",
    "mobile": "(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}",
    "national": "[025-7]\\d{7}"
  },
  "BG": {
    "premium_rate": "90\\d{6}",
    "toll_free": "(?:00800\\d\\d|800)\\d{5}",
    "shared_cost": "700\\d{5}",
    "fixed_line": "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",
    "mobile": "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
    "national": "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}"
  },
  "BH": {
    "premium_rate": "(?:87|9[0-8])\\d{6}",
    "toll_free": "8[02369]\\d{6}",
    "shared_cost": "84\\d{6}",
    "fixed_line": "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
    "mobile": "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}",
    "national": "[136-9]\\d{7}"
  },
  "BI": {
    "fixed_line": "(?:22|31)\\d{6}",
    "mobile": "(?:29|[67][125-9])\\d{6}",
    "national": "(?:[267]\\d|31)\\d{6}"
  },
  "BJ": {
    "voip": "857[58]\\d{4}",
    "uan": "81\\d{6}",
    "fixed_line": "2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}",
    "mobile": "(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}",
    "national": "[25689]\\d{7}"
  },
  "BN": {
    "voip": "5[34]\\d{5}",
    "fixed_line": "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",
    "mobile": "(?:22[89]|[78]\\d\\d)\\d{4}",
    "national": "[2-578]\\d{6}"
  },
  "BO": {
    "toll_free": "8001[07]\\d{4}",
    "voip": "50\\d{6}",
    "fixed_line": "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
    "mobile": "[67]\\d{7}",
    "national": "(?:[2-467]\\d\\d|8001)\\d{5}"
  },
  "BR": {
    "premium_rate": "300\\d{6}|[59]00\\d{6,7}",
    "toll_free": "800\\d{6,7}",
    "shared_cost": "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}",
    "fixed_line": "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
    "mobile": "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
    "national": "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}"
  },
  "BT": {
    "fixed_line": "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",
    "mobile": "(?:1[67]|77)\\d{6}",
    "national": "[17]\\d{7}|[2-8]\\d{6}"
  },
  "BW": {
    "premium_rate": "90\\d{5}",
    "toll_free": "(?:0800|800\\d)\\d{6}",
    "voip": "79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}",
    "fixed_line": "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
    "mobile": "(?:321|7[1-8]\\d)\\d{5}",
    "national": "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}"
  },
  "BY": {
    "premium_rate": "(?:810|902)\\d{7}",
    "toll_free": "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
    "voip": "249\\d{6}",
    "fixed_line": "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
    "mobile": "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
    "national": "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}"
  },
  "BZ": {
    "toll_free": "0800\\d{7}",
    "fixed_line": "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",
    "mobile": "6[0-35-7]\\d{5}",
    "national": "(?:0800\\d|[2-8])\\d{6}"
  },
  "CA": {
    "premium_rate": "900[2-9]\\d{6}",
    "toll_free": "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
    "voip": "600[2-9]\\d{6}",
    "personal_number": "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
    "uan": "310\\d{4}",
    "fixed_line": "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
    "national": "(?:[2-8]\\d|90)\\d{8}"
  },
  "CD": {
    "fixed_line": "(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}",
    "mobile": "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}",
    "national": "[189]\\d{8}|[1-68]\\d{6}"
  },
  "CF": {
    "premium_rate": "8776\\d{4}",
    "fixed_line": "2[12]\\d{6}",
    "mobile": "7[024-7]\\d{6}",
    "national": "(?:[27]\\d{3}|8776)\\d{4}"
  },
  "CG": {
    "premium_rate": "80[0-2]\\d{6}",
    "fixed_line": "222[1-589]\\d{5}",
    "mobile": "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
    "national": "222\\d{6}|(?:0\\d|80)\\d{7}"
  },
  "CH": {
    "premium_rate": "90[016]\\d{6}",
    "toll_free": "800\\d{6}",
    "shared_cost": "84[0248]\\d{6}",
    "personal_number": "878\\d{6}",
    "pager": "74[0248]\\d{6}",
    "uan": "5[18]\\d{7}",
    "voicemail": "860\\d{9}",
    "fixed_line": "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",
    "mobile": "(?:6[89]|7[235-9])\\d{7}",
    "national": "8\\d{11}|[2-9]\\d{8}"
  },
  "CI": {
    "fixed_line": "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",
    "mobile": "0[157]\\d{8}",
    "national": "[02]\\d{9}"
  },
  "CK": {
    "fixed_line": "(?:2\\d|3[13-7]|4[1-5])\\d{3}",
    "mobile": "[578]\\d{4}",
    "national": "[2-578]\\d{4}"
  },
  "CL": {
    "toll_free": "(?:123|8)00\\d{6}",
    "shared_cost": "600\\d{7,8}",
    "voip": "44\\d{7}",
    "fixed_line": "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
    "national": "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}"
  },
  "CM": {
    "toll_free": "88\\d{6,7}",
    "fixed_line": "2(?:22|33)\\d{6}",
    "mobile": "(?:24[23]|6(?:[25-9]\\d|40))\\d{6}",
    "national": "[26]\\d{8}|88\\d{6,7}"
  },
  "CN": {
    "premium_rate": "16[08]\\d{5}",
    "toll_free": "(?:(?:10|21)8|8)00\\d{7}",
    "shared_cost": "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
    "fixed_line": "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
    "mobile": "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
    "national": "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}"
  },
  "CO": {
    "premium_rate": "(?:19(?:0[01]|4[78])|901)\\d{7}",
    "toll_free": "1800\\d{7}",
    "fixed_line": "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}",
    "mobile": "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
    "national": "(?:1\\d|3)\\d{9}|[124-8]\\d{7}"
  },
  "CR": {
    "premium_rate": "90[059]\\d{7}",
    "toll_free": "800\\d{7}",
    "voip": "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
    "fixed_line": "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
    "mobile": "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
    "national": "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}"
  },
  "CU": {
    "toll_free": "800\\d{7}",
    "shared_cost": "807\\d{7}",
    "fixed_line": "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",
    "mobile": "(?:5\\d|6[2-4])\\d{6}",
    "national": "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}"
  },
  "CV": {
    "toll_free": "800\\d{4}",
    "voip": "(?:3[3-5]|4[356])\\d{5}",
    "fixed_line": "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
    "mobile": "(?:36|5[1-389]|9\\d)\\d{5}",
    "national": "(?:[2-59]\\d\\d|800)\\d{4}"
  },
  "CW": {
    "shared_cost": "60[0-2]\\d{4}",
    "pager": "955\\d{5}",
    "fixed_line": "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
    "mobile": "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",
    "national": "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}"
  },
  "CY": {
    "premium_rate": "90[09]\\d{5}",
    "toll_free": "800\\d{5}",
    "shared_cost": "80[1-9]\\d{5}",
    "personal_number": "700\\d{5}",
    "uan": "(?:50|77)\\d{6}",
    "fixed_line": "2[2-6]\\d{6}",
    "mobile": "9(?:10|[4-79]\\d)\\d{5}",
    "national": "(?:[279]\\d|[58]0)\\d{6}"
  },
  "CZ": {
    "premium_rate": "9(?:0[05689]|76)\\d{6}",
    "toll_free": "800\\d{6}",
    "shared_cost": "8[134]\\d{7}",
    "voip": "9[17]0\\d{6}",
    "personal_number": "70[01]\\d{6}",
    "uan": "9(?:5\\d|7[2-4])\\d{6}",
    "voicemail": "9(?:3\\d{9}|6\\d{7,10})",
    "fixed_line": "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",
    "mobile": "(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[01]|[2379]\\d\\d))\\d{5}",
    "national": "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}"
  },
  "DE": {
    "premium_rate": "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",
    "toll_free": "800\\d{7,12}",
    "shared_cost": "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",
    "personal_number": "700\\d{8}",
    "pager": "16(?:4\\d{1,10}|[89]\\d{1,11})",
    "uan": "18(?:1\\d{5,11}|[2-9]\\d{8})",
    "voicemail": "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
    "fixed_line": "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
    "mobile": "1(?:(?:5(?:[0-25-9]\\d\\d|310)|76\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}",
    "national": "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}"
  },
  "DJ": {
    "fixed_line": "2(?:1[2-5]|7[45])\\d{5}",
    "mobile": "77\\d{6}",
    "national": "(?:2\\d|77)\\d{6}"
  },
  "DK": {
    "premium_rate": "90\\d{6}",
    "toll_free": "80\\d{6}",
    "fixed_line": "(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}",
    "mobile": "(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}",
    "national": "[2-9]\\d{7}"
  },
  "DZ": {
    "premium_rate": "80[3-689]1\\d{5}",
    "toll_free": "800\\d{6}",
    "shared_cost": "80[12]1\\d{5}",
    "voip": "98[23]\\d{6}",
    "fixed_line": "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}",
    "mobile": "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
    "national": "(?:[1-4]|[5-79]\\d|80)\\d{7}"
  },
  "EC": {
    "toll_free": "1800\\d{7}|1[78]00\\d{6}",
    "voip": "[2-7]890\\d{4}",
    "fixed_line": "[2-7][2-7]\\d{6}",
    "mobile": "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
    "national": "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}"
  },
  "EE": {
    "premium_rate": "(?:40\\d\\d|900)\\d{4}",
    "toll_free": "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
    "personal_number": "70[0-2]\\d{5}",
    "fixed_line": "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
    "mobile": "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
    "national": "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}"
  },
  "EG": {
    "premium_rate": "900\\d{7}",
    "toll_free": "800\\d{7}",
    "fixed_line": "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",
    "mobile": "1[0-25]\\d{8}",
    "national": "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}"
  },
  "ER": {
    "fixed_line": "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",
    "mobile": "(?:17[1-3]|7\\d\\d)\\d{4}",
    "national": "[178]\\d{6}"
  },
  "ES": {
    "premium_rate": "80[367]\\d{6}",
    "toll_free": "[89]00\\d{6}",
    "shared_cost": "90[12]\\d{6}",
    "personal_number": "70\\d{7}",
    "uan": "51\\d{7}",
    "fixed_line": "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
    "mobile": "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",
    "national": "[5-9]\\d{8}"
  },
  "ET": {
    "fixed_line": "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
    "mobile": "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}",
    "national": "(?:11|[2-59]\\d)\\d{7}"
  },
  "FI": {
    "premium_rate": "[67]00\\d{5,6}",
    "toll_free": "800\\d{4,6}",
    "uan": "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
    "fixed_line": "1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
    "mobile": "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
    "national": "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}"
  },
  "FJ": {
    "toll_free": "0800\\d{7}",
    "fixed_line": "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",
    "mobile": "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
    "national": "45\\d{5}|(?:0800\\d|[235-9])\\d{6}"
  },
  "FM": {
    "fixed_line": "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
    "mobile": "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
    "national": "(?:[39]\\d\\d|820)\\d{4}"
  },
  "FO": {
    "premium_rate": "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
    "toll_free": "80[257-9]\\d{3}",
    "voip": "(?:6[0-36]|88)\\d{4}",
    "fixed_line": "(?:20|[34]\\d|8[19])\\d{4}",
    "mobile": "(?:[27][1-9]|5\\d|9[16])\\d{4}",
    "national": "[2-9]\\d{5}"
  },
  "FR": {
    "premium_rate": "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
    "toll_free": "80[0-5]\\d{6}",
    "shared_cost": "8(?:1[01]|2[0156]|4[024]|84)\\d{6}",
    "voip": "9\\d{8}",
    "uan": "80[6-9]\\d{6}",
    "fixed_line": "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}",
    "mobile": "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",
    "national": "[1-9]\\d{8}"
  },
  "GA": {
    "fixed_line": "[01]1\\d{6}",
    "mobile": "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
    "national": "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}"
  },
  "GB": {
    "premium_rate": "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
    "toll_free": "80[08]\\d{7}|800\\d{6}|8001111",
    "voip": "56\\d{8}",
    "personal_number": "70\\d{8}",
    "pager": "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
    "uan": "(?:3[0347]|55)\\d{8}",
    "fixed_line": "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
    "mobile": "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
    "national": "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}"
  },
  "GE": {
    "toll_free": "800\\d{6}",
    "voip": "70[67]\\d{6}",
    "fixed_line": "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",
    "mobile": "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
    "national": "(?:[3-57]\\d\\d|800)\\d{6}"
  },
  "GF": {
    "toll_free": "80[0-5]\\d{6}",
    "voip": "9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}",
    "fixed_line": "594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}",
    "mobile": "(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}",
    "national": "(?:[56]94|80\\d|976)\\d{6}"
  },
  "GH": {
    "toll_free": "800\\d{5}",
    "fixed_line": "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",
    "mobile": "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
    "national": "(?:[235]\\d{3}|800)\\d{5}"
  },
  "GI": {
    "fixed_line": "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
    "mobile": "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",
    "national": "(?:[25]\\d\\d|606)\\d{5}"
  },
  "GL": {
    "toll_free": "80\\d{4}",
    "voip": "3[89]\\d{4}",
    "fixed_line": "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}",
    "mobile": "[245]\\d{5}",
    "national": "(?:19|[2-689]\\d)\\d{4}"
  },
  "GM": {
    "fixed_line": "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",
    "mobile": "(?:[23679]\\d|4[015]|5[0-489])\\d{5}",
    "national": "[2-9]\\d{6}"
  },
  "GN": {
    "voip": "722\\d{6}",
    "fixed_line": "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",
    "mobile": "6[0-356]\\d{7}",
    "national": "722\\d{6}|(?:3|6\\d)\\d{7}"
  },
  "GP": {
    "toll_free": "80[0-5]\\d{6}",
    "voip": "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",
    "fixed_line": "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}",
    "mobile": "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}",
    "national": "(?:590|(?:69|80)\\d|976)\\d{6}"
  },
  "GQ": {
    "premium_rate": "90\\d[1-9]\\d{5}",
    "toll_free": "80\\d[1-9]\\d{5}",
    "fixed_line": "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",
    "mobile": "(?:222|55\\d)\\d{6}",
    "national": "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}"
  },
  "GR": {
    "premium_rate": "90[19]\\d{7}",
    "toll_free": "800\\d{7,9}",
    "shared_cost": "8(?:0[16]|12|[27]5|50)\\d{7}",
    "personal_number": "70\\d{8}",
    "uan": "5005000\\d{3}",
    "fixed_line": "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
    "mobile": "68[57-9]\\d{7}|(?:69|94)\\d{8}",
    "national": "5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}"
  },
  "GT": {
    "premium_rate": "19\\d{9}",
    "toll_free": "18[01]\\d{8}",
    "fixed_line": "[267][2-9]\\d{6}",
    "mobile": "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
    "national": "(?:1\\d{3}|[2-7])\\d{7}"
  },
  "GW": {
    "voip": "40\\d{5}",
    "fixed_line": "443\\d{6}",
    "mobile": "9(?:5\\d|6[569]|77)\\d{6}",
    "national": "[49]\\d{8}|4\\d{6}"
  },
  "GY": {
    "premium_rate": "9008\\d{3}",
    "toll_free": "(?:289|8(?:00|6[28]|88|99))\\d{4}",
    "voip": "515\\d{4}",
    "fixed_line": "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
    "mobile": "510\\d{4}|(?:6\\d|7[0-5])\\d{5}",
    "national": "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}"
  },
  "HK": {
    "premium_rate": "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
    "toll_free": "800\\d{6}",
    "personal_number": "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
    "pager": "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
    "uan": "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",
    "fixed_line": "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}",
    "mobile": "(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4])|7(?:4[0-2]|6[0-5]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[05])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-49]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
    "national": "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}"
  },
  "HN": {
    "toll_free": "8002\\d{7}",
    "fixed_line": "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
    "mobile": "[37-9]\\d{7}",
    "national": "8\\d{10}|[237-9]\\d{7}"
  },
  "HR": {
    "premium_rate": "6[01459]\\d{6}|6[01]\\d{4,5}",
    "toll_free": "80\\d{5,7}",
    "personal_number": "7[45]\\d{6}",
    "uan": "62\\d{6,7}|72\\d{6}",
    "fixed_line": "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
    "mobile": "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}",
    "national": "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}"
  },
  "HT": {
    "toll_free": "8\\d{7}",
    "voip": "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
    "fixed_line": "2(?:2\\d|5[1-5]|81|9[149])\\d{5}",
    "mobile": "(?:[34]\\d|55)\\d{6}",
    "national": "[2-489]\\d{7}"
  },
  "HU": {
    "premium_rate": "9[01]\\d{6}",
    "toll_free": "(?:[48]0\\d|680[29])\\d{5}",
    "voip": "21\\d{7}",
    "uan": "38\\d{7}",
    "fixed_line": "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",
    "mobile": "(?:[257]0|3[01])\\d{7}",
    "national": "[235-7]\\d{8}|[1-9]\\d{7}"
  },
  "ID": {
    "premium_rate": "809\\d{7}",
    "toll_free": "00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}",
    "shared_cost": "804\\d{7}",
    "uan": "(?:1500|8071\\d{3})\\d{3}",
    "fixed_line": "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
    "mobile": "8[1-35-9]\\d{7,10}",
    "national": "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}"
  },
  "IE": {
    "premium_rate": "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
    "toll_free": "1800\\d{6}",
    "shared_cost": "18[59]0\\d{6}",
    "voip": "76\\d{7}",
    "personal_number": "700\\d{6}",
    "uan": "818\\d{6}",
    "voicemail": "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",
    "fixed_line": "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",
    "mobile": "8(?:22|[35-9]\\d)\\d{6}",
    "national": "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}"
  },
  "IL": {
    "premium_rate": "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}",
    "toll_free": "1(?:255|80[019]\\d{3})\\d{3}",
    "shared_cost": "1700\\d{6}",
    "voip": "7(?:38(?:0\\d|5[0-2569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
    "uan": "1599\\d{6}",
    "voicemail": "151\\d{8,9}",
    "fixed_line": "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
    "mobile": "55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
    "national": "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}"
  },
  "IN": {
    "premium_rate": "186[12]\\d{9}",
    "toll_free": "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",
    "shared_cost": "1860\\d{7}",
    "uan": "140\\d{7}",
    "fixed_line": "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
    "mobile": "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
    "national": "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}"
  },
  "IO": {
    "fixed_line": "37\\d{5}",
    "mobile": "38\\d{5}",
    "national": "3\\d{6}"
  },
  "IQ": {
    "fixed_line": "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
    "mobile": "7[3-9]\\d{8}",
    "national": "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}"
  },
  "IR": {
    "uan": "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
    "fixed_line": "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}",
    "mobile": "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",
    "national": "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}"
  },
  "IS": {
    "premium_rate": "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
    "toll_free": "80[0-8]\\d{4}",
    "voip": "49[0-24-79]\\d{4}",
    "uan": "809\\d{4}",
    "voicemail": "(?:689|8(?:7[18]|80)|95[48])\\d{4}",
    "fixed_line": "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",
    "mobile": "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",
    "national": "(?:38\\d|[4-9])\\d{6}"
  },
  "IT": {
    "premium_rate": "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
    "toll_free": "80(?:0\\d{3}|3)\\d{3}",
    "shared_cost": "84(?:[08]\\d{3}|[17])\\d{3}",
    "voip": "55\\d{8}",
    "personal_number": "1(?:78\\d|99)\\d{6}",
    "voicemail": "3[2-8]\\d{9,10}",
    "fixed_line": "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
    "mobile": "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
    "national": "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}"
  },
  "JO": {
    "premium_rate": "9\\d{7}",
    "toll_free": "80\\d{6}",
    "shared_cost": "85\\d{6}",
    "personal_number": "70\\d{7}",
    "pager": "74(?:66|77)\\d{5}",
    "uan": "8(?:10|8\\d)\\d{5}",
    "fixed_line": "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
    "mobile": "7(?:[78][0-25-9]|9\\d)\\d{6}",
    "national": "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}"
  },
  "JP": {
    "premium_rate": "990\\d{6}",
    "toll_free": "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",
    "voip": "50[1-9]\\d{7}",
    "personal_number": "60\\d{7}",
    "pager": "20\\d{8}",
    "uan": "570\\d{6}",
    "fixed_line": "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",
    "mobile": "(?:60\\d|[7-9]0[1-9])\\d{7}",
    "national": "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}"
  },
  "KE": {
    "premium_rate": "900[02-9]\\d{5}",
    "toll_free": "800[02-8]\\d{5,6}",
    "fixed_line": "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
    "mobile": "(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}",
    "national": "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}"
  },
  "KG": {
    "toll_free": "800\\d{6,7}",
    "fixed_line": "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
    "mobile": "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
    "national": "8\\d{9}|(?:[235-8]\\d|99)\\d{7}"
  },
  "KH": {
    "premium_rate": "1900(?:1\\d|2[09])\\d{4}",
    "toll_free": "1800(?:1\\d|2[019])\\d{4}",
    "fixed_line": "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
    "mobile": "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
    "national": "1\\d{9}|[1-9]\\d{7,8}"
  },
  "KM": {
    "premium_rate": "8\\d{6}",
    "fixed_line": "7[4-7]\\d{5}",
    "mobile": "[34]\\d{6}",
    "national": "[3478]\\d{6}"
  },
  "KP": {
    "fixed_line": "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",
    "mobile": "19[1-3]\\d{7}",
    "national": "85\\d{6}|(?:19\\d|[2-7])\\d{7}"
  },
  "KR": {
    "premium_rate": "60[2-9]\\d{6}",
    "toll_free": "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}",
    "voip": "70\\d{8}",
    "personal_number": "50\\d{8,9}",
    "pager": "15\\d{7,8}",
    "uan": "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}",
    "fixed_line": "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
    "mobile": "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
    "national": "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}"
  },
  "KW": {
    "toll_free": "18\\d{5}",
    "fixed_line": "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",
    "mobile": "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
    "national": "(?:18|[2569]\\d\\d)\\d{5}"
  },
  "LA": {
    "uan": "30[0135-9]\\d{6}",
    "fixed_line": "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
    "mobile": "208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}",
    "national": "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}"
  },
  "LB": {
    "premium_rate": "9[01]\\d{6}",
    "shared_cost": "80\\d{6}",
    "fixed_line": "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",
    "mobile": "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}",
    "national": "[27-9]\\d{7}|[13-9]\\d{6}"
  },
  "LI": {
    "premium_rate": "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
    "toll_free": "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",
    "uan": "870(?:28|87)\\d\\d",
    "voicemail": "697(?:42|56|[78]\\d)\\d{4}",
    "fixed_line": "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
    "mobile": "(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",
    "national": "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}"
  },
  "LK": {
    "uan": "1973\\d{5}",
    "fixed_line": "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
    "mobile": "7(?:[0-25-8]\\d|4[0-4])\\d{6}",
    "national": "[1-9]\\d{8}"
  },
  "LR": {
    "premium_rate": "332(?:02|[34]\\d)\\d{4}",
    "fixed_line": "2\\d{7}",
    "mobile": "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}",
    "national": "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}"
  },
  "LS": {
    "toll_free": "800[1256]\\d{4}",
    "fixed_line": "2\\d{7}",
    "mobile": "[56]\\d{7}",
    "national": "(?:[256]\\d\\d|800)\\d{5}"
  },
  "LT": {
    "premium_rate": "9(?:0[0239]|10)\\d{5}",
    "toll_free": "80[02]\\d{5}",
    "shared_cost": "808\\d{5}",
    "voip": "[89]01\\d{5}",
    "personal_number": "70[05]\\d{5}",
    "uan": "70[67]\\d{5}",
    "fixed_line": "(?:3[1478]|4[124-6]|52)\\d{6}",
    "mobile": "6\\d{7}",
    "national": "(?:[3469]\\d|52|[78]0)\\d{6}"
  },
  "LU": {
    "premium_rate": "90[015]\\d{5}",
    "toll_free": "800\\d{5}",
    "shared_cost": "801\\d{5}",
    "voip": "20(?:1\\d{5}|[2-689]\\d{1,7})",
    "fixed_line": "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
    "mobile": "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
    "national": "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}"
  },
  "LV": {
    "premium_rate": "90\\d{6}",
    "toll_free": "80\\d{6}",
    "shared_cost": "81\\d{6}",
    "fixed_line": "6\\d{7}",
    "mobile": "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}",
    "national": "(?:[268]\\d|90)\\d{6}"
  },
  "LY": {
    "fixed_line": "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",
    "mobile": "9[1-6]\\d{7}",
    "national": "[2-9]\\d{8}"
  },
  "MA": {
    "premium_rate": "89\\d{7}",
    "toll_free": "80[0-7]\\d{6}",
    "voip": "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
    "fixed_line": "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",
    "mobile": "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}",
    "national": "[5-8]\\d{8}"
  },
  "MC": {
    "toll_free": "(?:800|90\\d)\\d{5}",
    "fixed_line": "(?:870|9[2-47-9]\\d)\\d{5}",
    "mobile": "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",
    "national": "(?:[3489]|6\\d)\\d{7}"
  },
  "MD": {
    "premium_rate": "90[056]\\d{5}",
    "toll_free": "800\\d{5}",
    "shared_cost": "808\\d{5}",
    "voip": "3[08]\\d{6}",
    "uan": "803\\d{5}",
    "fixed_line": "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",
    "mobile": "562\\d{5}|(?:6\\d|7[16-9])\\d{6}",
    "national": "(?:[235-7]\\d|[89]0)\\d{6}"
  },
  "ME": {
    "premium_rate": "9(?:4[1568]|5[178])\\d{5}",
    "toll_free": "80(?:[0-2578]|9\\d)\\d{5}",
    "voip": "78[1-49]\\d{5}",
    "uan": "77[1-9]\\d{5}",
    "fixed_line": "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
    "mobile": "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
    "national": "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}"
  },
  "MG": {
    "voip": "22\\d{7}",
    "fixed_line": "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}",
    "mobile": "3[2-47-9]\\d{7}",
    "national": "[23]\\d{8}"
  },
  "MH": {
    "voip": "635\\d{4}",
    "fixed_line": "(?:247|528|625)\\d{4}",
    "mobile": "(?:(?:23|54)5|329|45[35-8])\\d{4}",
    "national": "329\\d{4}|(?:[256]\\d|45)\\d{5}"
  },
  "MK": {
    "premium_rate": "5\\d{7}",
    "toll_free": "800\\d{5}",
    "shared_cost": "8(?:0[1-9]|[1-9]\\d)\\d{5}",
    "fixed_line": "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",
    "mobile": "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
    "national": "[2-578]\\d{7}"
  },
  "ML": {
    "toll_free": "80\\d{6}",
    "fixed_line": "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
    "mobile": "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}",
    "national": "[24-9]\\d{7}"
  },
  "MM": {
    "toll_free": "80080(?:0[1-9]|2\\d)\\d{3}",
    "voip": "1333\\d{4}|[12]468\\d{4}",
    "fixed_line": "(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
    "mobile": "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
    "national": "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}"
  },
  "MN": {
    "voip": "712[0-79]\\d{4}|7(?:1[013-9]|[5-9]\\d)\\d{5}",
    "fixed_line": "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",
    "mobile": "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}",
    "national": "[12]\\d{7,9}|[57-9]\\d{7}"
  },
  "MO": {
    "toll_free": "0800\\d{3}",
    "fixed_line": "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
    "mobile": "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
    "national": "(?:28|[68]\\d)\\d{6}"
  },
  "MQ": {
    "premium_rate": "8[129]\\d{7}",
    "toll_free": "80[0-5]\\d{6}",
    "voip": "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
    "fixed_line": "(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}",
    "mobile": "(?:69[67]\\d\\d|7091[0-3])\\d{4}",
    "national": "(?:69|80)\\d{7}|(?:59|97)6\\d{6}"
  },
  "MR": {
    "toll_free": "800\\d{5}",
    "fixed_line": "(?:25[08]|35\\d|45[1-7])\\d{5}",
    "mobile": "[2-4][0-46-9]\\d{6}",
    "national": "(?:[2-4]\\d\\d|800)\\d{5}"
  },
  "MT": {
    "premium_rate": "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
    "toll_free": "800(?:02|[3467]\\d)\\d{3}",
    "voip": "3550\\d{4}",
    "pager": "7117\\d{4}",
    "uan": "501\\d{5}",
    "fixed_line": "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",
    "mobile": "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",
    "national": "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}"
  },
  "MU": {
    "premium_rate": "30\\d{5}",
    "toll_free": "802\\d{7}|80[0-2]\\d{4}",
    "voip": "3(?:20|9\\d)\\d{4}",
    "fixed_line": "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",
    "mobile": "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}",
    "national": "(?:[2-468]|5\\d)\\d{6}"
  },
  "MV": {
    "premium_rate": "900\\d{7}",
    "toll_free": "800\\d{7}",
    "uan": "4(?:0[01]|50)\\d{4}",
    "fixed_line": "(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
    "mobile": "(?:46[46]|[79]\\d\\d)\\d{4}",
    "national": "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}"
  },
  "MW": {
    "fixed_line": "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
    "mobile": "111\\d{6}|(?:31|77|[89][89])\\d{7}",
    "national": "(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}"
  },
  "MX": {
    "premium_rate": "900\\d{7}",
    "toll_free": "8(?:00|88)\\d{7}",
    "shared_cost": "300\\d{7}",
    "personal_number": "500\\d{7}",
    "fixed_line": "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
    "mobile": "657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
    "national": "(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}"
  },
  "MY": {
    "premium_rate": "1600\\d{6}",
    "toll_free": "1[378]00\\d{6}",
    "voip": "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
    "fixed_line": "4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
    "mobile": "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
    "national": "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}"
  },
  "MZ": {
    "toll_free": "800\\d{6}",
    "fixed_line": "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",
    "mobile": "8[2-79]\\d{7}",
    "national": "(?:2|8\\d)\\d{7}"
  },
  "NA": {
    "premium_rate": "8701\\d{5}",
    "toll_free": "80\\d{7}",
    "voip": "8(?:3\\d\\d|86)\\d{5}",
    "fixed_line": "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
    "mobile": "(?:60|8[1245])\\d{7}",
    "national": "[68]\\d{7,8}"
  },
  "NC": {
    "premium_rate": "36\\d{4}",
    "toll_free": "050\\d{3}",
    "fixed_line": "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",
    "mobile": "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",
    "national": "[2-57-9]\\d{5}"
  },
  "NE": {
    "premium_rate": "09\\d{6}",
    "toll_free": "08\\d{6}",
    "fixed_line": "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
    "mobile": "(?:23|7[0467]|[89]\\d)\\d{6}",
    "national": "[027-9]\\d{7}"
  },
  "NF": {
    "fixed_line": "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",
    "mobile": "(?:14|3[58])\\d{4}",
    "national": "[13]\\d{5}"
  },
  "NG": {
    "toll_free": "800\\d{7,11}",
    "uan": "700\\d{7,11}",
    "fixed_line": "(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}",
    "mobile": "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}",
    "national": "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}"
  },
  "NI": {
    "toll_free": "1800\\d{4}",
    "fixed_line": "2\\d{7}",
    "mobile": "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
    "national": "(?:1800|[25-8]\\d{3})\\d{4}"
  },
  "NL": {
    "premium_rate": "90[069]\\d{4,7}",
    "toll_free": "800\\d{4,7}",
    "voip": "(?:85|91)\\d{7}",
    "pager": "66\\d{7}",
    "uan": "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",
    "fixed_line": "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
    "mobile": "(?:6[1-58]|970\\d)\\d{7}",
    "national": "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}"
  },
  "NO": {
    "premium_rate": "82[09]\\d{5}",
    "toll_free": "80[01]\\d{5}",
    "shared_cost": "810(?:0[0-6]|[2-8]\\d)\\d{3}",
    "voip": "85[0-5]\\d{5}",
    "personal_number": "880\\d{5}",
    "uan": "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
    "voicemail": "81[23]\\d{5}",
    "fixed_line": "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
    "mobile": "(?:4[015-8]|9\\d)\\d{6}",
    "national": "(?:0|[2-9]\\d{3})\\d{4}"
  },
  "NP": {
    "toll_free": "1(?:66001|800\\d\\d)\\d{5}",
    "fixed_line": "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
    "mobile": "9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}",
    "national": "(?:1\\d|9)\\d{9}|[1-9]\\d{7}"
  },
  "NR": {
    "fixed_line": "444\\d{4}",
    "mobile": "(?:55[3-9]|666|8\\d\\d)\\d{4}",
    "national": "(?:444|(?:55|8\\d)\\d|666)\\d{4}"
  },
  "NU": {
    "fixed_line": "[47]\\d{3}",
    "mobile": "(?:[56]|888[1-9])\\d{3}",
    "national": "(?:[47]|888\\d)\\d{3}"
  },
  "NZ": {
    "premium_rate": "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",
    "toll_free": "508\\d{6,7}|80\\d{6,8}",
    "personal_number": "70\\d{7}",
    "uan": "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}",
    "fixed_line": "240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
    "mobile": "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
    "national": "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}"
  },
  "OM": {
    "premium_rate": "900\\d{5}",
    "toll_free": "8007\\d{4,5}|(?:500|800[05])\\d{4}",
    "fixed_line": "2[1-6]\\d{6}",
    "mobile": "(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}",
    "national": "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}"
  },
  "PA": {
    "premium_rate": "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",
    "toll_free": "800\\d{4,5}|(?:00800|800\\d)\\d{6}",
    "fixed_line": "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
    "mobile": "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
    "national": "8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}"
  },
  "PE": {
    "premium_rate": "805\\d{5}",
    "toll_free": "800\\d{5}",
    "shared_cost": "801\\d{5}",
    "personal_number": "80[24]\\d{5}",
    "fixed_line": "(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
    "mobile": "9\\d{8}",
    "national": "(?:[14-8]|9\\d)\\d{7}"
  },
  "PF": {
    "toll_free": "80[0-5]\\d{6}",
    "voip": "499\\d{5}",
    "uan": "44\\d{4}",
    "fixed_line": "4(?:0[4-689]|9[4-68])\\d{5}",
    "mobile": "8[7-9]\\d{6}",
    "national": "4\\d{5}(?:\\d{2})?|8\\d{7,8}"
  },
  "PG": {
    "toll_free": "180\\d{4}",
    "voip": "2(?:0[0-57]|7[568])\\d{4}",
    "pager": "27[01]\\d{4}",
    "fixed_line": "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",
    "mobile": "(?:7\\d|8[1-38])\\d{6}",
    "national": "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}"
  },
  "PH": {
    "toll_free": "1800\\d{7,9}",
    "fixed_line": "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
    "mobile": "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
    "national": "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}"
  },
  "PK": {
    "premium_rate": "900\\d{5}",
    "toll_free": "800\\d{5}(?:\\d{3})?",
    "personal_number": "122\\d{6}",
    "uan": "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
    "fixed_line": "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",
    "mobile": "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
    "national": "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}"
  },
  "PL": {
    "premium_rate": "70[01346-8]\\d{6}",
    "toll_free": "800\\d{6,7}",
    "shared_cost": "801\\d{6}",
    "voip": "39\\d{7}",
    "pager": "64\\d{4,7}",
    "uan": "804\\d{6}",
    "fixed_line": "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",
    "mobile": "21(?:1[013-5]|2\\d|3[4-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
    "national": "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?"
  },
  "PM": {
    "premium_rate": "8[129]\\d{7}",
    "toll_free": "80[0-5]\\d{6}",
    "fixed_line": "(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}",
    "mobile": "(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}",
    "national": "(?:[45]|80\\d\\d)\\d{5}"
  },
  "PR": {
    "premium_rate": "900[2-9]\\d{6}",
    "toll_free": "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
    "personal_number": "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
    "fixed_line": "(?:787|939)[2-9]\\d{6}",
    "national": "(?:[589]\\d\\d|787)\\d{7}"
  },
  "PS": {
    "toll_free": "1800\\d{6}",
    "shared_cost": "1700\\d{6}",
    "fixed_line": "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
    "mobile": "5[69]\\d{7}",
    "national": "[2489]2\\d{6}|(?:1\\d|5)\\d{8}"
  },
  "PT": {
    "premium_rate": "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
    "toll_free": "80[02]\\d{6}",
    "shared_cost": "80(?:8\\d|9[1579])\\d{5}",
    "voip": "30\\d{7}",
    "personal_number": "884[0-4689]\\d{5}",
    "pager": "6(?:222\\d|8988)\\d{4}",
    "uan": "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}",
    "voicemail": "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}",
    "fixed_line": "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",
    "mobile": "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",
    "national": "(?:[26-9]\\d|30)\\d{7}"
  },
  "PW": {
    "fixed_line": "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
    "mobile": "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}",
    "national": "(?:[24-8]\\d\\d|345|900)\\d{4}"
  },
  "PY": {
    "toll_free": "9800\\d{5,7}",
    "voip": "8700[0-4]\\d{4}",
    "uan": "[2-9]0\\d{4,7}",
    "fixed_line": "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
    "mobile": "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",
    "national": "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}"
  },
  "QA": {
    "toll_free": "800\\d{4}|(?:0080[01]|800)\\d{6}",
    "pager": "2[16]\\d{5}",
    "fixed_line": "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
    "mobile": "[35-7]\\d{7}",
    "national": "[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}"
  },
  "RE": {
    "premium_rate": "89[1-37-9]\\d{6}",
    "toll_free": "80\\d{7}",
    "shared_cost": "8(?:1[019]|2[0156]|84|90)\\d{6}",
    "voip": "9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}",
    "fixed_line": "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}",
    "mobile": "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}",
    "national": "9769\\d{5}|(?:26|[68]\\d)\\d{7}"
  },
  "RO": {
    "premium_rate": "90[0136]\\d{6}",
    "toll_free": "800\\d{6}",
    "shared_cost": "801\\d{6}",
    "uan": "(?:37\\d|80[578])\\d{6}",
    "fixed_line": "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
    "mobile": "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
    "national": "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}"
  },
  "RS": {
    "premium_rate": "(?:78\\d|90[0169])\\d{3,7}",
    "toll_free": "800\\d{3,9}",
    "uan": "7[06]\\d{4,10}",
    "fixed_line": "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",
    "mobile": "6(?:[0-689]|7\\d)\\d{6,7}",
    "national": "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}"
  },
  "RU": {
    "premium_rate": "80[39]\\d{7}",
    "toll_free": "8(?:0[04]|108\\d{3})\\d{7}",
    "personal_number": "808\\d{7}",
    "fixed_line": "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
    "mobile": "9\\d{9}",
    "national": "[347-9]\\d{9}"
  },
  "RW": {
    "premium_rate": "900\\d{6}",
    "toll_free": "800\\d{6}",
    "fixed_line": "(?:06|2[23568]\\d)\\d{6}",
    "mobile": "7[237-9]\\d{7}",
    "national": "(?:06|[27]\\d\\d|[89]00)\\d{6}"
  },
  "SA": {
    "premium_rate": "925\\d{6}",
    "toll_free": "800\\d{7}",
    "shared_cost": "920\\d{6}",
    "uan": "811\\d{7}",
    "fixed_line": "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",
    "mobile": "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
    "national": "92\\d{7}|(?:[15]|8\\d)\\d{8}"
  },
  "SB": {
    "toll_free": "1[38]\\d{3}",
    "voip": "5[12]\\d{3}",
    "fixed_line": "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",
    "mobile": "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",
    "national": "(?:[1-6]|[7-9]\\d\\d)\\d{4}"
  },
  "SC": {
    "premium_rate": "85\\d{5}",
    "toll_free": "800[08]\\d{3}",
    "voip": "971\\d{4}|(?:64|95)\\d{5}",
    "fixed_line": "4[2-46]\\d{5}",
    "mobile": "2[125-8]\\d{5}",
    "national": "8000\\d{3}|(?:[249]\\d|64)\\d{5}"
  },
  "SD": {
    "fixed_line": "1(?:5\\d|8[35-7])\\d{6}",
    "mobile": "(?:1[0-2]|9[0-3569])\\d{7}",
    "national": "[19]\\d{8}"
  },
  "SE": {
    "premium_rate": "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",
    "toll_free": "20\\d{4,7}",
    "shared_cost": "77[0-7]\\d{6}",
    "personal_number": "75[1-8]\\d{6}",
    "pager": "74[02-9]\\d{6}",
    "uan": "10[1-8]\\d{6}",
    "voicemail": "(?:25[245]|67[3-68])\\d{9}",
    "fixed_line": "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
    "mobile": "7[02369]\\d{7}",
    "national": "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}"
  },
  "SG": {
    "premium_rate": "1900\\d{7}",
    "toll_free": "(?:18|8)00\\d{7}",
    "voip": "(?:3[12]\\d|666)\\d{5}",
    "uan": "7000\\d{7}",
    "fixed_line": "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
    "mobile": "896[0-4]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-5])|9[0-8]\\d)\\d{5}",
    "national": "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}"
  },
  "SI": {
    "premium_rate": "89[1-3]\\d{2,5}|90\\d{4,6}",
    "toll_free": "80\\d{4,6}",
    "voip": "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",
    "fixed_line": "(?:[1-357][2-8]|4[24-8])\\d{6}",
    "mobile": "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
    "national": "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}"
  },
  "SK": {
    "premium_rate": "9(?:00|[78]\\d)\\d{6}",
    "toll_free": "800\\d{6}",
    "shared_cost": "8[5-9]\\d{7}",
    "voip": "6(?:02|5[0-4]|9[0-6])\\d{6}",
    "pager": "9090\\d{3}",
    "uan": "96\\d{7}",
    "fixed_line": "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",
    "mobile": "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
    "national": "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}"
  },
  "SL": {
    "fixed_line": "22[2-4][2-9]\\d{4}",
    "mobile": "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
    "national": "(?:[237-9]\\d|66)\\d{6}"
  },
  "SM": {
    "premium_rate": "7[178]\\d{6}",
    "voip": "5[158]\\d{6}",
    "fixed_line": "0549(?:8[0157-9]|9\\d)\\d{4}",
    "mobile": "6[16]\\d{6}",
    "national": "(?:0549|[5-7]\\d)\\d{6}"
  },
  "SN": {
    "premium_rate": "88[4689]\\d{6}",
    "toll_free": "800\\d{6}",
    "shared_cost": "81[02468]\\d{6}",
    "voip": "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",
    "fixed_line": "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",
    "mobile": "7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[36]|[4-7]\\d|8[35]))\\d{5}",
    "national": "(?:[378]\\d{4}|93330)\\d{4}"
  },
  "SO": {
    "fixed_line": "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
    "mobile": "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
    "national": "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}"
  },
  "SR": {
    "voip": "56\\d{4}",
    "fixed_line": "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",
    "mobile": "(?:7[124-7]|8[124-9])\\d{5}",
    "national": "(?:[2-5]|68|[78]\\d)\\d{5}"
  },
  "SS": {
    "fixed_line": "1[89]\\d{7}",
    "mobile": "(?:12|9[1257-9])\\d{7}",
    "national": "[19]\\d{8}"
  },
  "ST": {
    "fixed_line": "22\\d{5}",
    "mobile": "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",
    "national": "(?:22|9\\d)\\d{5}"
  },
  "SV": {
    "premium_rate": "900\\d{4}(?:\\d{4})?",
    "toll_free": "800\\d{8}|80[01]\\d{4}",
    "fixed_line": "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
    "mobile": "[67]\\d{7}",
    "national": "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?"
  },
  "SY": {
    "fixed_line": "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",
    "mobile": "(?:50|9[1-689])\\d{7}",
    "national": "[1-39]\\d{8}|[1-5]\\d{7}"
  },
  "SZ": {
    "premium_rate": "900\\d{6}",
    "toll_free": "0800\\d{4}",
    "voip": "70\\d{6}",
    "fixed_line": "[23][2-5]\\d{6}",
    "mobile": "7[6-9]\\d{6}",
    "national": "0800\\d{4}|(?:[237]\\d|900)\\d{6}"
  },
  "TD": {
    "fixed_line": "22(?:[37-9]0|5[0-5]|6[89])\\d{4}",
    "mobile": "(?:[69]\\d|77|8[56])\\d{6}",
    "national": "(?:22|[69]\\d|77)\\d{6}"
  },
  "TG": {
    "fixed_line": "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
    "mobile": "(?:7[0-29]|9[0-36-9])\\d{6}",
    "national": "[279]\\d{7}"
  },
  "TH": {
    "premium_rate": "1900\\d{6}",
    "toll_free": "(?:001800\\d|1800)\\d{6}",
    "voip": "6[08]\\d{7}",
    "fixed_line": "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",
    "mobile": "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
    "national": "1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}"
  },
  "TJ": {
    "fixed_line": "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
    "mobile": "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0178]|2[02]|[34]0|5[05]|7[01578]|8[078])\\d{7}",
    "national": "(?:00|11|[2-57-9]\\d)\\d{7}"
  },
  "TL": {
    "premium_rate": "90\\d{5}",
    "toll_free": "80\\d{5}",
    "personal_number": "70\\d{5}",
    "fixed_line": "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",
    "mobile": "7[2-8]\\d{6}",
    "national": "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}"
  },
  "TM": {
    "fixed_line": "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",
    "mobile": "(?:6\\d|71)\\d{6}",
    "national": "[1-6]\\d{7}"
  },
  "TN": {
    "premium_rate": "88\\d{6}",
    "toll_free": "8010\\d{4}",
    "shared_cost": "8[12]10\\d{4}",
    "fixed_line": "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",
    "mobile": "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
    "national": "[2-57-9]\\d{7}"
  },
  "TO": {
    "toll_free": "0800\\d{3}",
    "voip": "55[0-37-9]\\d{4}",
    "fixed_line": "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",
    "mobile": "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
    "national": "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}"
  },
  "TR": {
    "premium_rate": "(?:8[89]8|900)\\d{7}",
    "toll_free": "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",
    "voip": "850\\d{7}",
    "personal_number": "592(?:21[12]|461)\\d{4}",
    "pager": "512\\d{7}",
    "uan": "444\\d{4}",
    "fixed_line": "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
    "mobile": "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",
    "national": "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}"
  },
  "TV": {
    "fixed_line": "2[02-9]\\d{3}",
    "mobile": "(?:7[01]\\d|90)\\d{4}",
    "national": "(?:2|7\\d\\d|90)\\d{4}"
  },
  "TW": {
    "premium_rate": "20(?:[013-9]\\d\\d|2)\\d{4}",
    "toll_free": "80[0-79]\\d{6}|800\\d{5}",
    "voip": "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",
    "personal_number": "99\\d{7}",
    "uan": "50[0-46-9]\\d{6}",
    "fixed_line": "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
    "mobile": "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
    "national": "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}"
  },
  "TZ": {
    "premium_rate": "90\\d{7}",
    "toll_free": "80[08]\\d{6}",
    "shared_cost": "8(?:40|6[01])\\d{6}",
    "voip": "41\\d{7}",
    "fixed_line": "2[2-8]\\d{7}",
    "mobile": "(?:6[125-9]|7[13-9])\\d{7}",
    "national": "(?:[26-8]\\d|41|90)\\d{7}"
  },
  "UA": {
    "premium_rate": "900[239]\\d{5,6}",
    "toll_free": "800[1-8]\\d{5,6}",
    "voip": "89[1-579]\\d{6}",
    "fixed_line": "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
    "mobile": "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}",
    "national": "[89]\\d{9}|[3-9]\\d{8}"
  },
  "UG": {
    "premium_rate": "90[1-3]\\d{6}",
    "toll_free": "800[1-3]\\d{5}",
    "fixed_line": "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
    "mobile": "72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-7]|9[89])\\d{6}",
    "national": "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}"
  },
  "US": {
    "premium_rate": "900[2-9]\\d{6}",
    "toll_free": "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
    "voip": "305209\\d{4}",
    "personal_number": "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
    "fixed_line": "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
    "national": "[2-9]\\d{9}"
  },
  "UY": {
    "premium_rate": "90[0-8]\\d{4}",
    "toll_free": "0004\\d{2,9}|(?:405|80[05])\\d{4}",
    "fixed_line": "(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}",
    "mobile": "9[1-9]\\d{6}",
    "national": "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}"
  },
  "UZ": {
    "fixed_line": "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}",
    "mobile": "(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
    "national": "(?:33|55|[679]\\d|88)\\d{7}"
  },
  "VE": {
    "premium_rate": "90[01]\\d{7}",
    "toll_free": "800\\d{7}",
    "uan": "501\\d{7}",
    "fixed_line": "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",
    "mobile": "4(?:1[24-8]|2[46])\\d{7}",
    "national": "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}"
  },
  "VN": {
    "premium_rate": "1900\\d{4,6}",
    "toll_free": "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
    "voip": "672\\d{6}",
    "uan": "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
    "fixed_line": "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",
    "mobile": "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
    "national": "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}"
  },
  "VU": {
    "toll_free": "81[18]\\d\\d",
    "voip": "9(?:0[1-9]|1[01])\\d{4}",
    "uan": "(?:3[03]|900\\d)\\d{3}",
    "fixed_line": "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",
    "mobile": "(?:[58]\\d|7[013-7])\\d{5}",
    "national": "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}"
  },
  "WF": {
    "toll_free": "80[0-5]\\d{6}",
    "voip": "9[23]\\d{4}",
    "voicemail": "[48]0\\d{4}",
    "fixed_line": "72\\d{4}",
    "mobile": "(?:72|8[23])\\d{4}",
    "national": "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?"
  },
  "WS": {
    "toll_free": "800\\d{3}",
    "fixed_line": "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",
    "mobile": "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",
    "national": "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}"
  },
  "XK": {
    "premium_rate": "900\\d{5}",
    "toll_free": "800\\d{5}",
    "fixed_line": "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})",
    "mobile": "4[3-9]\\d{6}",
    "national": "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}"
  },
  "YE": {
    "fixed_line": "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",
    "mobile": "7[01378]\\d{7}",
    "national": "(?:1|7\\d)\\d{7}|[1-7]\\d{6}"
  },
  "ZA": {
    "premium_rate": "(?:86[2-9]|9[0-2]\\d)\\d{6}",
    "toll_free": "80\\d{7}",
    "shared_cost": "860\\d{6}",
    "voip": "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
    "uan": "861\\d{6,7}",
    "fixed_line": "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
    "mobile": "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
    "national": "[1-79]\\d{8}|8\\d{4,9}"
  },
  "ZM": {
    "toll_free": "800\\d{6}",
    "voip": "63\\d{7}",
    "fixed_line": "21[1-8]\\d{6}",
    "mobile": "(?:7[5-79]|9[5-8])\\d{7}",
    "national": "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}"
  },
  "ZW": {
    "toll_free": "80(?:[01]\\d|20|8[0-8])\\d{3}",
    "voip": "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",
    "fixed_line": "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
    "mobile": "7(?:[1278]\\d|3[1-9])\\d{6}",
    "national": "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}"
  }
}